export default __webpack_public_path__ + "static/media/rhb.3caea59a.svg";